import { colors, weights } from '@components/theme/styles/index';
import { styled } from '@mui/material';
import { rem } from 'polished';

export const IndicatorContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: rem(12),
  marginBottom: rem(15),
  marginTop: rem(15),
});

export const Divider = styled('div')({
  flex: '1 1 0%',
  height: rem(1),
  backgroundColor: colors.grayLight1,
});

export const TextContent = styled('div')({
  display: 'flex',
  alignItems: 'center',
  flexShrink: 0,
  gap: rem(8),
});

export const IconWrapper = styled('span')<{ $isPrivate: boolean }>(
  ({ $isPrivate }) => ({
    display: 'flex',
    alignItems: 'center',
    color: $isPrivate ? colors.blueDark3 : colors.grayDark3,
    fontSize: rem(12),
  }),
);

export const IndicatorText = styled('span')<{ $isPrivate: boolean }>(
  ({ $isPrivate }) => ({
    fontSize: rem(12),
    fontWeight: weights.medium,
    color: $isPrivate ? colors.blueDark3 : colors.grayDark3,
    whiteSpace: 'nowrap',
  }),
);
